import { managerInstance } from "libs/api";

import { CompanyManager, UpdateManagerRequest } from "../../managers.types";

export const requestUpdateManager = async ({
  id,
  ...body
}: UpdateManagerRequest): Promise<CompanyManager> => {
  return await managerInstance.patch(`/delivery-company/managers/${id}`, body);
};
